import dxDataGrid from 'devextreme/ui/data_grid'
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const pdfExporter = async (component: dxDataGrid, selectedRowsOnly: boolean = false) => {
    const doc = new jsPDF({
        orientation: 'l',
        format: 'a2',
    })

    autoTable(doc, {
        theme: 'plain',
        horizontalPageBreak: true,
        tableLineColor: 'black',
        styles: {
            lineColor: 'black',
        }
    })

    return exportDataGridToPdf({
            jsPDFDocument: doc,
            component,
            selectedRowsOnly: selectedRowsOnly,
        }).then(() => {
            doc.save('Customers.pdf')
        })
}
